var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIconProfession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/places/business_center_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4H8V3L7 2H5L4 3V4H2C1.45 4 1 4.45 1 5V6.5C1 7.055 1.445 7.5 2 7.5H5V6.5H7V7.5H10C10.55 7.5 11 7.05 11 6.5V5C11 4.45 10.55 4 10 4ZM5 8.5V8H1.505L1.5 10C1.5 10.555 1.945 11 2.5 11H9.5C10.055 11 10.5 10.555 10.5 10V8H7V8.5H5ZM5 4H7V3H5V4Z",
    fill: "#310048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconProfession);
export default __webpack_public_path__ + "static/media/card_icon_profession.557f02a6535eeabbddafe02f40d05f46.svg";
export { ForwardRef as ReactComponent };